<script lang="ts" setup>
import {computed, type ComputedRef, isReadonly} from "vue";
import type {SynchroRequestField, SynchroRequestFieldList} from "@/domain/type/synchro.api.type.ts";

const props = defineProps<{
  requestFields: SynchroRequestFieldList,
}>()

const emit = defineEmits(['submitSrc1', 'submitSrc2'])

const src1HasInput = computed(function () {
  let hasInput = false
  for (const request of Object.values(props.requestFields)) {
    if (0 < request.valueSrc1.length && !request.readOnlySrc2 && !request.isSynchronized) {
      hasInput = true
    }
  }
  return hasInput
})
const src1IsReadonly: ComputedRef<boolean> = computed(function () {
  let isReadonly = true;
  for (const request of Object.values(props.requestFields)) {
    if (!request.readOnlySrc1) {
      isReadonly = false
    }
  }
  return isReadonly
})
const src2IsReadonly: ComputedRef<boolean> = computed(function () {
  let isReadonly = true;
  for (const request of Object.values(props.requestFields)) {
    if (!request.readOnlySrc2) {
      isReadonly = false
    }
  }
  return isReadonly
})
const src2HasInput = computed(function () {
  let hasInput = false
  for (const request of Object.values(props.requestFields)) {
    if (0 < request.valueSrc2.length && !request.readOnlySrc1 && !request.isSynchronized) {
      hasInput = true
    }
  }
  return hasInput
})

const listIsEmpty = computed(() => {
  return 0 === Object.values(props.requestFields).length
})

</script>

<template>
  <div v-if="!listIsEmpty" class="fusionAction d-flex align-center justify-center flex-nowrap">
    <v-btn
      :disabled="!src1HasInput || src2IsReadonly"
      append-icon="mdi-arrow-right"
      class="takeSrc1"
      color="green"
      :density="$vuetify.display.smAndUp ? 'comfortable' : 'default'"
      variant="outlined"
      text="tout"
      @click="emit('submitSrc1')"
    />

    <v-divider vertical class="mx-2 divider-spacing" />

    <div class="action-spacing">
      <slot name="actions"/>
    </div>

    <v-divider vertical class="mx-2 divider-spacing" />

    <v-btn
      :disabled="!src2HasInput || src1IsReadonly"
      prepend-icon="mdi-arrow-left"
      class="takeSrc2"
      color="green"
      :density="$vuetify.display.smAndUp ? 'comfortable' : 'default'"
      variant="outlined"
      text="tout"
      @click="emit('submitSrc2')"
    />
  </div>
</template>

<style scoped>
.fusionAction {
  animation: slideUp 0.3s ease-out;
  gap: 0;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 600px) {
  .divider-spacing {
    margin-left: 4px !important;
    margin-right: 4px !important;
  }

  .action-spacing {
    margin-left: 4px;
    margin-right: 4px;
  }
}
</style>
